export default __webpack_public_path__ + "1c94f928110d152954a31301d4017eab.jpg";